import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import { Button } from 'reactstrap';
import ArticlesForm from '../../Inventory/Articles/components/ArticlesForm';

const ModalInventoryList = ({ closeModal, opened, preAddItemArticle }) => {

    useEffect(() => {

    }, []);

    const handleCloseModal = () => {
        closeModal();
    }

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Inventario</h5>
                        </div>
                        <ArticlesForm articlesInvoiceProcess={true} preAddItemArticle={preAddItemArticle} />
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                handleCloseModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
export default ModalInventoryList;
